import { Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { map } from 'rxjs/operators';

import { AuthService } from '@/auth/services';
import { DataTableComponent } from '@/components';
import {
    DataTableColumnType,
    FilterType
} from '@/enums';
import {
    ActionLog,
    DataTableColumn
} from '@/interfaces';
import { UserViewComponent } from '@/pages';
import { ActionLogsService } from '@/service';

@Component({
    selector: 'app-action-logs-listing',
    standalone: true,
    templateUrl: 'listing.component.html',
    imports: [DataTableComponent],
    providers: [DialogService]
})
export class ActionLogListingComponent {

    columns: DataTableColumn<ActionLog>[] = [
        {
            field: 'user.name',
            header: 'User',
            type: DataTableColumnType.MODAL,
            modalComponent: UserViewComponent,
            modalTitle: 'User Details',
            modalData: (row: ActionLog) => ({ user: row.user }),
            filterType: FilterType.AUTOCOMPLETE,
            autocompleteCompleteMethod: (q, context) => this.actionAutocomplete('user.name', q, context),
            frozen: true
        },
        {
            field: 'action_code',
            header: 'Action',
            filterType: FilterType.AUTOCOMPLETE,
            autocompleteCompleteMethod: (q, context) => this.actionAutocomplete('action_code', q, context),
        },
        {
            field: 'context',
            header: 'Context',
            type: DataTableColumnType.JSON,
            sortable: false,
            filterable: false,
        },
        {
            field: 'created_at',
            header: 'Created At',
            type: DataTableColumnType.DATETIME,
            filterType: FilterType.DATE
        }
    ];

    constructor(
        public authService: AuthService,
        private actionLogsService: ActionLogsService
    ) {
    }

    loadData = (params: Record<string, any>) => this.actionLogsService.listing(params);

    exportData = (params: Record<string, any>) => this.actionLogsService.export(params);

    actionAutocomplete(field: 'action_code' | 'user.name', query: string, context: Record<string, any> = {}) {
        return this.actionLogsService.autocomplete(field, query, context).pipe(map((res) => res.data ?? res));
    }
}
